import type { ReactNode } from "react";

import { filterPillClass } from "./filterPillClass";

/** A pílula de filtro dos detalhes do Diagnóstico; o de scope items usa a mesma. */
export function FilterButton({
  active,
  onClick,
  children,
  testId,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  testId?: string;
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-pressed={active}
      onClick={onClick}
      className={filterPillClass(active)}
    >
      {children}
    </button>
  );
}
